<div class="mat-table">
    <div class="table_principal">
        <table mat-table [dataSource]="matDataSourceBP" matSort (matSortChange)="trieTab($event)" matSortActive="dBp"
            matSortDirection="desc" matSortDisableClear>
            <caption>Liste des Bps lignes</caption>
            <ng-container matColumnDef="selectRow" *ngIf="ifListAValide === true">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox 
                        (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" 
                        [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="align-cell">
                    <mat-checkbox 
                        (click)="$event.stopPropagation()" 
                        (change)="$event ? selectRow(row) : null"
                        [checked]="selection.isSelected(row)" 
                        [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="societe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Société </th>
                <td mat-cell *matCellDef="let element" matTooltip="{{element.societe.libelle}}" class="centrer no-padding">
                    {{element.societe.code}} </td>
            </ng-container>

            <ng-container matColumnDef="codeSite">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Site </th>
                <td mat-cell *matCellDef="let element">
                    <div class="with-padding-left">
                        {{element.codeSite}}-{{element.libelleSite}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.status}} </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° Pièce </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.code}} </td>
            </ng-container>
            
            <ng-container matColumnDef="NBc">
                <th mat-header-cell *matHeaderCellDef> N° BCs </th>
                <td mat-cell *matCellDef="let element" class="centrer">
                    <div *ngIf="element.bcs">
                        <ul style="list-style-type:square;padding-left: 15px;">
                            <ng-template ngFor let-item [ngForOf]="element.bcs.split(',')">  
                                <li *ngIf="item !== ''">
                                    <span mat-list-item>{{item}}</span>
                                </li>
                            </ng-template>
                        </ul>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="dBp">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.dBp | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="codeFourn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fournisseur </th>
                <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.codeFourn" matTooltip="{{element.libelleFourn}}" class="centrer">
                        {{element.codeFourn}}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="ttc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant TTC </th>
                <td mat-cell *matCellDef="let element" class="allign-right" [matTooltip]="element.total">
                    <div *ngIf="element.ttc"  class="with-padding-right"> 
                        {{element.ttc | currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="facture">
                <th mat-header-cell *matHeaderCellDef> F </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon green" *ngIf="element.bFacture">
                        check_circle</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="bloque">
                <th mat-header-cell *matHeaderCellDef> B </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon red" *ngIf="element.bBloque">
                        cancel</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="numFacture">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° Facture </th>
                <td mat-cell *matCellDef="let element" class="centrer">{{element.numFacture}} </td>
            </ng-container>
            <ng-container matColumnDef="dFacture">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de facture </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.dFacture| date:'dd/MM/yyyy'}}</td>
            </ng-container>
            <ng-container matColumnDef="codeCa1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> CA1 </th>
                <td mat-cell *matCellDef="let element" matTooltip="{{element.libelleCa1}}" class="centrer">
                    {{element.codeCa1}}
                </td>
            </ng-container>
            <ng-container matColumnDef="trigrammeCreateur">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Créateur </th>
                <td mat-cell *matCellDef="let element" matTooltip="{{getAssociatedUser(element)}}" class="centrer">
                    {{getAssociatedUserTrigram(element)}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsBP ;sticky: true"></tr>
            <div *ngIf="!ifListAValide">
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBP;" (click)="editBP(row); selectRow(row);"
                    [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}">
                </tr>
            </div>
            <div *ngIf="ifListAValide">
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBP;" (click)="editBP(row);"
                    [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}">
                </tr>
            </div>

        </table>
        <div class="footer">
            <mat-paginator #paginator class="paginator" [length]="this.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                [pageSizeOptions]="[25, 50, 150]" (page)="changePage($event)">
            </mat-paginator>
        </div>

    </div>
</div>